import { useOutcomingMessageStyle } from './useOutcomingMessageStyle';
import { EMessageType } from '../../../types/messageType';
import { TMessage } from '../../../types/messages';

export const useMessageType = ({ isOutcoming, userId, isRead, isDeleted }: TMessage) => {
  const isOutcomingMessage = useOutcomingMessageStyle(isOutcoming, userId);

  if (!isRead && !isOutcomingMessage && !isDeleted) {
    return EMessageType.Unread;
  }

  return isOutcomingMessage ? EMessageType.Outcoming : EMessageType.Incoming;
};
